import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Common } from '@thecvlb/design-system';
import Cookies from 'js-cookie';

import { selectOrchestrate } from 'store';

import { NewPasswordFormInput } from 'pages/AccountSettings/ChangePassword/NewPasswordForm/newPasswordForm.types';

import { ReducedSignupStepProps } from 'containers/SignUp/Content/content.types';
import NewPasswordInput from 'shared/form/NewPasswordInput';
import { notifySuccess } from 'shared/Toast/Toast';

import { useAppSelector } from 'hooks';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';

import Heading from '../../components/Heading';

const SetPassword: React.FC<ReducedSignupStepProps> = ({ moveToStep }) => {
  const {
    user: { firstName }
  } = useAppSelector(selectOrchestrate);
  const { control, handleSubmit, getValues, setValue } = useForm<NewPasswordFormInput>({
    criteriaMode: 'all',
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { send, isLoading } = useSubmitOrchestrateForm();
  const dummyPWLength = Cookies.get('p-length');

  const onSubmit = () => {
    if (dummyPWLength) {
      return moveToStep('next');
    }
    const password = getValues('newPassword');
    if (password) {
      send('user', { password }, () => {
        Cookies.set('p-length', password.length.toString(), {
          expires: 7
        });
        moveToStep('next');
      });
    }
  };

  useEffect(() => {
    if (dummyPWLength) {
      setValue('newPassword', new Array(Number(dummyPWLength)).fill('*').join(''));
      notifySuccess('The password has been set successfully');
    }
  }, []);

  return (
    <form className="flex h-full flex-col gap-6" onSubmit={handleSubmit(onSubmit)}>
      <Heading
        category="About you"
        title={`${firstName}, please create a secure password to sign up.`}
      />
      <NewPasswordInput
        control={control}
        disabled={!!dummyPWLength}
        label="Password"
        name="newPassword"
        placeholder="Enter your password..."
        size="lg"
      />
      <Common.Button
        className="max-md:mt-auto md:mx-auto"
        color="blue"
        isLoading={isLoading}
        fullWidthOnMobile
      >
        Continue
      </Common.Button>
    </form>
  );
};

export default SetPassword;
